import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
interface OfferCardProps {
  onCtaClick: () => void;
}
export function OfferCard({
  onCtaClick
}: OfferCardProps) {
  const benefits = ['Acceso de por vida al protocolo', 'Actualizaciones gratis para siempre', 'Bonus: Checklist de Salud Mental Canina'];
  return <section className="py-24 px-5" data-id="element-79">
      <FadeInUp className="max-w-lg mx-auto bg-white rounded-3xl border-2 border-slate-dark shadow-2xl overflow-hidden relative" data-id="element-80">
        <div className="bg-pistachio text-slate-dark text-center py-3 font-bold tracking-wider text-sm" data-id="element-81">
          OFERTA DE LANZAMIENTO
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-82">
          <div className="mb-8" data-id="element-83">
            <span className="text-slate-dark/40 line-through text-xl font-medium block mb-2" data-id="element-84">
              Precio normal: $24.990
            </span>
            <div className="text-6xl font-serif font-bold text-slate-dark" data-id="element-85">
              $4.990{' '}
              <span className="text-2xl font-sans text-slate-dark/60" data-id="element-86">CLP</span>
            </div>
          </div>

          <div className="space-y-4 mb-10 text-left" data-id="element-87">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-88">
                <CheckCircleIcon className="w-6 h-6 text-pistachio shrink-0" data-id="element-89" />
                <span className="text-slate-dark font-medium" data-id="element-90">{benefit}</span>
              </div>)}
          </div>

          <ShimmerButton onClick={onCtaClick} className="w-full text-lg mb-8" data-id="element-91">
            DESCARGAR TODO AHORA
          </ShimmerButton>

          <div className="flex justify-center items-center gap-4 text-slate-dark/40 text-sm font-medium grayscale opacity-70" data-id="element-92">
            <span data-id="element-93">VISA</span>
            <span data-id="element-94">•</span>
            <span data-id="element-95">MASTERCARD</span>
            <span data-id="element-96">•</span>
            <span data-id="element-97">MERCADO PAGO</span>
          </div>
        </div>
      </FadeInUp>
    </section>;
}